import { ConfigProvider, App as AntdApp } from 'antd';
import viVN from 'antd/es/locale/vi_VN';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import { themeConfig } from './styles/theme';
import { queryClient } from './lib/queryClient';
import './lib/pdf-init';

const RootApp = () => (
  <React.StrictMode>
    <ConfigProvider theme={themeConfig} locale={viVN}>
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  </React.StrictMode>
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<RootApp />);
